import Image from 'next/image'
import { VFC } from 'react'

export type CTitleProps = {
    src: string
    title: string
    subtitle?: boolean
    additionalClassName?: string
}

export type CTitleViewProps = {} & CTitleProps

export const Title: VFC<CTitleViewProps> = ({ src, title, subtitle, additionalClassName = '' }) => {
    return (
        <div className={`flex justify-center relative ${subtitle ? 'h-10' : 'h-12'} ` + additionalClassName}>
            <Image src={src} alt={title} layout="fill" objectFit="contain" />
        </div>
    )
}

export default Title
